// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.thumbnail[data-v-61502fb8]{\n\twidth: 20px;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tbackground-position: center;\n\tdisplay: inline-block;\n}\n.image-name[data-v-61502fb8] {\n\twhite-space:nowrap;\n\t-ms-flex-negative: 1;\n\t    flex-shrink: 1;\n\toverflow:hidden;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
